import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.INFRASTRUCTURE_TAGS].GET_INFRASTRUCTURE_TAGS]: {
		url: '/company/:companyId/infrastructure_tags/',
	},
	[ModulesConfigMap[ModulesMap.INFRASTRUCTURE_TAGS].GET_INFRASTRUCTURE_TAGS_PREVIEW]: {
		url: '/company/:companyId/infrastructure_tags/:infrastructureTagsId/preview/',
	},
	[ModulesConfigMap[ModulesMap.INFRASTRUCTURE_TAGS].GET_INFRASTRUCTURE_TAG]: {
		url: '/company/:companyId/infrastructure_tags/:infrastructureTagsId/',
	},
	[ModulesConfigMap[ModulesMap.INFRASTRUCTURE_TAGS].CREATE_INFRASTRUCTURE_TAGS]: {
		url: '/company/:companyId/infrastructure_tags/',
		requestOptions: {
			method: 'POST',
		},
	},
	[ModulesConfigMap[ModulesMap.INFRASTRUCTURE_TAGS].PATCH_INFRASTRUCTURE_TAGS]: {
		url: '/company/:companyId/infrastructure_tags/:infrastructureTagsId/',
		requestOptions: {
			method: 'PATCH',
		},
	},
	[ModulesConfigMap[ModulesMap.INFRASTRUCTURE_TAGS].PUT_INFRASTRUCTURE_TAGS]: {
		url: '/company/:companyId/infrastructure_tags/:infrastructureTagsId/',
		requestOptions: {
			method: 'PUT',
		},
	},
	[ModulesConfigMap[ModulesMap.INFRASTRUCTURE_TAGS].DELETE_INFRASTRUCTURE_TAGS]: {
		url: '/company/:companyId/infrastructure_tags/:infrastructureTagsId/',
		requestOptions: {
			method: 'DELETE',
		},
	},
}
